import {
  IWeeklyTimelineItem,
  TaskPriority,
  TaskStatus,
  TaskStatusWordMap,
} from '../../timelineItem';
import classNames from 'classnames';
import { GeoAlt } from 'react-bootstrap-icons';
import { FiCheckCircle } from 'react-icons/fi';

import { VscInfo } from 'react-icons/vsc';
import { replaceStrVariable } from '../../../../utils/replaceStrVariable';
import { useTranslation } from 'react-i18next';
import { FaBuilding } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../../../hooks/usePermissions';
import { PermissionEnum } from '../../../../enums/PermissionEnum';
import DefaultButton from '../../../../components/buttons/DefaultButton';
import PrimaryButton from '../../../../components/buttons/PrimaryButton';
import Tag from '../../../../components/tag/Tag';
import { LegalMetroTaskTypeEnum, TaskTypeEnum } from '../../../../enums/TaskTypeEnum';
import { useEffect, useState } from 'react';
import { referenceDataSyncService } from '../../../../services/referenceDataSyncService';

export const WeeklyInspectionItem = (props: IWeeklyTimelineItem) => {
  const {
    status,
    establishmentType,
    taskName,
    location,
    numberOfProducts,
    reportLink,
    priority,
    productId,
    refId,
    assignees,
    basketId,
    locationId,
    establishmentId,
    taskTypeKey,
    subTaskTypeKey,
    fuelStationName,
  } = props;

  const { t } = useTranslation(['inspector', 'task']);

  const { hasPermission } = usePermissions();

  const [productName, setProductName] = useState<string | undefined>(undefined);

  const navigate = useNavigate();

  const startPriceRecord = () => {
    const taskData = {
      assignees,
      basketId,
      establishmentId,
      establishmentType,
      locationId,
      priority,
      productRefIds: productId,
      refId,
      triggeredFrom: 'inspections',
    };

    if (taskTypeKey === TaskTypeEnum.LEGAL_METROLOGY_INSPECTION) {
      switch (subTaskTypeKey) {
        case LegalMetroTaskTypeEnum.PRE_PACKAGED_PRODUCT_VERIFICATION:
          navigate('/inspector/pre-packaged-product-verification', {
            state: taskData,
          });
          break;
        case LegalMetroTaskTypeEnum.SCALE_FORMAT_VERIFICATION:
          navigate('/inspector/scale-format-verification', {
            state: taskData,
          });
          break;
        case LegalMetroTaskTypeEnum.FUEL_DISPENSER_VERIFICATION:
          navigate('/inspector/fuel-dispenser-verification', {
            state: taskData,
          });
          break;
      }
    } else {
      navigate('/inspector/price-record', {
        state: taskData,
      });
    }
  };

  useEffect(() => {
    const getProductName = async () => {
      try {
        const productData: any = await referenceDataSyncService.getProductDataById(productId[0]);

        productData && setProductName(productData[0]?.data?.name);
      } catch (error) {}
    };
    if (subTaskTypeKey === LegalMetroTaskTypeEnum.PRE_PACKAGED_PRODUCT_VERIFICATION) {
      getProductName();
    }
  }, []);

  return (
    <div>
      <div className="rounded-lg border bg-white p-4">
        {/* Task Type Tag */}
        {/* <div className="flex flex-row flex-wrap gap-2 mb-2 bg-red-100"> */}
        <div className="md-items-center mb-2 flex w-full flex-col items-start justify-between gap-2 md:flex-row">
          <div className="flex flex-row flex-wrap gap-2">
            <Tag
              tagType={taskTypeKey === TaskTypeEnum.LEGAL_METROLOGY_INSPECTION ? 'brown' : 'info'}
              filled={true}
            >
              {t(`task:taskTypeEnum.${taskTypeKey}`)}
            </Tag>

            {taskTypeKey === TaskTypeEnum.LEGAL_METROLOGY_INSPECTION && (
              <Tag
                tagType={'default'}
                /* tagType={
                    subTaskTypeKey === LegalMetroTaskTypeEnum.SCALE_FORMAT_VERIFICATION
                      ? 'default'
                      : subTaskTypeKey === LegalMetroTaskTypeEnum.PRE_PACKAGED_PRODUCT_VERIFICATION
                        ? 'purple'
                        : 'neutral'
                  } */
                filled={false}
              >
                {t(`task:legalMetroTaskTypeEnum.${subTaskTypeKey}`)}
              </Tag>
            )}
          </div>
          <div className="flex md:items-center">
            <Tag
              tagType={
                priority === TaskPriority.HIGH
                  ? 'danger'
                  : priority === TaskPriority.MEDIUM
                    ? 'warning'
                    : 'neutral'
              }
              filled={false}
            >
              {t(`inspector:${priority}`)}
            </Tag>
          </div>
        </div>

        <div className="flex flex-row items-center justify-between">
          <div className="flex w-full flex-col items-start gap-2 sm:w-fit sm:flex-row sm:items-center">
            <div className="flex flex-row items-center gap-2">
              <FaBuilding />
              <h5 className="font-semibold text-gray-900">
                {subTaskTypeKey === LegalMetroTaskTypeEnum.FUEL_DISPENSER_VERIFICATION
                  ? fuelStationName
                  : establishmentType}
              </h5>
            </div>
            <div className="flex flex-row flex-wrap gap-2">
              {/* <div
                className={classNames(
                  'rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize transition-colors sm:ml-4',
                  { 'border-primary bg-primary text-white': status === TaskStatus.COMPLETED },
                  { 'bg-[#f5f5f5] text-black': status === TaskStatus.IN_PROGRESS },
                  { 'border-primary-red bg-primary-red text-white': status === TaskStatus.DELAYED },
                  { 'border-gray-500 bg-gray-500 text-white': status === TaskStatus.CANCELLED }
                )}
              >
                {TaskStatusWordMap[status]}
              </div> */}
              <Tag
                tagType={
                  status === TaskStatus.COMPLETED
                    ? 'success'
                    : status === TaskStatus.IN_PROGRESS
                      ? 'caution'
                      : status === TaskStatus.DELAYED
                        ? 'danger'
                        : status === TaskStatus.PENDING
                          ? 'warning'
                          : 'neutral'
                }
                filled={true}
              >
                {t(`inspector:${status}`)}
              </Tag>
            </div>

            {/* <div
                className={classNames(
                  'rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize',
                  {
                    'border-primary-red bg-primary-red text-white': priority === TaskPriority.HIGH,
                  },
                  {
                    'border-yellow-500 bg-yellow-500 text-yellow-50':
                      priority === TaskPriority.MEDIUM,
                  }
                )}
              >
                {priority}
              </div> */}
          </div>
        </div>

        <div className="mt-3 flex flex-row pt-4 sm:mt-2 md:pt-0">
          <h5 className="text-sm font-medium text-gray-900 md:text-base">{taskName}</h5>
        </div>

        <div className="my-2 grid w-full grid-cols-1 gap-2 sm:my-0.5 sm:grid-cols-2">
          <div className="mt-2 flex flex-row items-center gap-2 text-sm md:text-base">
            <GeoAlt /> {location}
          </div>

          <div className="flex flex-row-reverse items-center justify-end gap-4 py-4 sm:flex-row md:py-0">
            {status === TaskStatus.IN_PROGRESS &&
            hasPermission([PermissionEnum.RUN_INSPECTIONS]) ? (
              <>
                {/* <VscInfo className="text-xl text-primary" /> */}
                <PrimaryButton
                  hideBgGradient={true}
                  handleOnClick={() => {
                    startPriceRecord();
                  }}
                  className="primary-btn--chip"
                >
                  {t('inspector:continue')}
                </PrimaryButton>
              </>
            ) : (status === TaskStatus.PENDING || status === TaskStatus.DELAYED) &&
              hasPermission([PermissionEnum.RUN_INSPECTIONS]) ? (
              <PrimaryButton
                hideBgGradient={true}
                handleOnClick={() => {
                  startPriceRecord();
                }}
                className="primary-btn--chip"
              >
                {t('inspector:start')}
              </PrimaryButton>
            ) : null}
          </div>
        </div>

        {/* Consumer Price Inspection - Establishment and number of products */}
        {/* PRE_PACKAGED_PRODUCT_VERIFICATION - product Name */}
        <div className="mt-4 flex flex-row flex-wrap items-start justify-start gap-2">
          {taskTypeKey === TaskTypeEnum.LEGAL_METROLOGY_INSPECTION ? (
            subTaskTypeKey === LegalMetroTaskTypeEnum.PRE_PACKAGED_PRODUCT_VERIFICATION && (
              <>
                <div className="flex flex-row items-center text-sm">{productName}</div>
              </>
            )
          ) : (
            <>
              <div
                className={classNames(
                  'inline-flex rounded-full border bg-card-bg-color px-2.5 py-0.5 text-xs font-semibold capitalize'
                )}
              >
                {establishmentType}
              </div>
              <div className="flex flex-row items-center text-sm">
                {t('inspector:numberOfProducts', { numberOfProducts })}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default WeeklyInspectionItem;
